$('a[href^="#"]').on('click', function () {
  const speed = 500;
  const easing = 'swing';
  const href = $(this).attr('href');
  const target = $(href == '#' || href == '' ? 'html' : href);
  const spt = parseInt($('html').css('scrollPaddingTop')) || 0;
  const smt = parseInt($(target).css('scrollMarginTop')) || 0;
  // スクロール先
  const position = target.offset().top - (spt + smt);
  $('html, body').animate({ scrollTop: position }, speed, easing);
  return false;
});

// 外部リンクのアニメーション
var urlHash = location.hash;
var headerHeight = $('.header').outerHeight(true);
if (urlHash) {
  $('body,html').stop().scrollTop(0);
  setTimeout(function() {
    var target = $(urlHash);
    var position = target.offset().top - headerHeight;
    $('body,html').stop().animate({
      scrollTop: position
    }, 500);
  }, 100);
}

// SP nav - ハンバーガーメニュー
$(document).ready(function () {
  // PCナビゲーションの追従処理（トップページのみ）
  if (window.matchMedia("(min-width: 769px)").matches) {
    // 下層ページの場合はHTMLで最初からis-fixedクラスが付与されているので、
    // スクロールイベントは登録しない
    if (!$('.js-header-fixed').hasClass('is-fixed')) {
      // トップページ：スクロールイベントを設定
      $(window).off('scroll.headerFixed');
      $(window).on('scroll.headerFixed', function () {
        const headerTopHeight = $('.header-top').outerHeight() || 0;
        if ($(window).scrollTop() > headerTopHeight) {
          $('.js-header-fixed').addClass('is-fixed');
        } else {
          $('.js-header-fixed').removeClass('is-fixed');
        }
      });
    }
  }

  // ハンバーガーボタンのクリックイベント
  $('.js-header-hamburger').on('click', function () {
    $(this).toggleClass('is-active');
    $('.js-header-drawer').toggleClass('is-active');
    // ドロワーが開いているときはbodyのスクロールを防ぐ
    if ($('.js-header-drawer').hasClass('is-active')) {
      $('body').css('overflow', 'hidden');
    } else {
      $('body').css('overflow', '');
    }
  });

  // ドロワーメニュー内のリンクをクリックしたらメニューを閉じる
  $('.js-header-drawer a').on('click', function (e) {
    // アコーディオントリガー（診療メニュー）の場合は何もしない
    if ($(this).parent().hasClass('js-accordion-trigger')) {
      return;
    }
    // サブメニュー内のリンクの場合はメニューを閉じる
    if ($(this).closest('.js-accordion-content').length > 0) {
      $('.js-header-hamburger').removeClass('is-active');
      $('.js-header-drawer').removeClass('is-active');
      $('body').css('overflow', '');
      // アコーディオンも閉じる
      $('.js-accordion-trigger').removeClass('is-open');
      $('.js-accordion-content').slideUp(0);
      return;
    }
    // 通常のリンクの場合はメニューを閉じる
    $('.js-header-hamburger').removeClass('is-active');
    $('.js-header-drawer').removeClass('is-active');
    $('body').css('overflow', '');
  });

  // SPアコーディオンメニュー
  $('.js-accordion-trigger > a').on('click', function (e) {
    e.preventDefault();
    const $parent = $(this).parent('.js-accordion-trigger');
    const $submenu = $parent.find('.js-accordion-content');
    
    // 他のアコーディオンを閉じる
    $('.js-accordion-trigger').not($parent).removeClass('is-open');
    $('.js-accordion-content').not($submenu).slideUp(300);
    
    // クリックしたアコーディオンを開閉
    $parent.toggleClass('is-open');
    $submenu.slideToggle(300);
  });
});

if (window.matchMedia("(max-width: 768px)").matches) {
  $(function () {
    $(window).on("scroll", function () {
      const sliderHeight = $(".topMv").height();
      if (sliderHeight - 30 < $(this).scrollTop()) {
        $(".js-header-sp").addClass("is-headerOn");
      } else {
        $(".js-header-sp").removeClass("is-headerOn");
      }
    });
  });

  $(function () {
    $(window).on("scroll", function () {
      scrollHeight = $(document).height();
      scrollPosition = $(window).height() + $(window).scrollTop();
      footHeight = $(".js-footer-sp").innerHeight();
      if (scrollHeight - scrollPosition <= footHeight) {
        $(".js-cv-sp").addClass("is-none");
      } else {
        $(".js-cv-sp").removeClass("is-none");
      }
    });
  });

  jQuery(function($) {
    $('.js-sp-navDown').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).next().slideToggle();
      $(this).toggleClass('is-on');
      return false;
    });
  });
}

jQuery(function($) {
  //tab
  $(function () {
    $('.js-tab .js-tabItem').click(function () {
      var index = $('.js-tab .js-tabItem').index(this);
      $('.js-tab .js-tabItem').removeClass('is-on');
      $(this).addClass('is-on');
      $('.js-tabArea .js-tabcCntents').removeClass('is-on').eq(index).addClass('is-on');
    });
  });

  // ScrollHint初期化
  if (typeof ScrollHint !== 'undefined') {
    new ScrollHint('.table-scroll-wrapper', {
      suggestiveShadow: false,
      i18n: {
        scrollable: 'スクロールできます'
      }
    });
  }

  // SEC09 アコーディオン（ヘッダー全体で開閉）
  $('.sec09-leftBox__accordion__item__header__text').on('click', function() {
    const $item = $(this).closest('.sec09-leftBox__accordion__item');
    const $body = $item.find('.sec09-leftBox__accordion__item__body');
    const isExpanded = $item.attr('aria-expanded') === 'true';
    
    // アコーディオンの開閉
    if (isExpanded) {
      $item.attr('aria-expanded', 'false');
      $body.css('max-height', '0');
    } else {
      $item.attr('aria-expanded', 'true');
      const scrollHeight = $body[0].scrollHeight;
      $body.css('max-height', scrollHeight + 'px');
    }
  });

  // 症例ページのフィルタープルダウン
  $('#worry-filter, #treatment-filter').on('change', function() {
    const worryValue = $('#worry-filter').val();
    const treatmentValue = $('#treatment-filter').val();
    const baseUrl = window.location.pathname;
    const params = new URLSearchParams();
    
    if (worryValue) {
      params.set('worry', worryValue);
    }
    if (treatmentValue) {
      params.set('treatment', treatmentValue);
    }
    
    const queryString = params.toString();
    const newUrl = queryString ? baseUrl + '?' + queryString : baseUrl;
    window.location.href = newUrl;
  });

  // お悩み相談一覧のアコーディオン（faq-layout 領域クリックで開閉）
  $(document).on('click', '.sec-concernsList__item__header', function() {
    const $item = $(this).closest('.sec-concernsList__item');
    const isExpanded = $item.attr('aria-expanded') === 'true';
    $item.attr('aria-expanded', isExpanded ? 'false' : 'true');
  });

  // お悩み相談一覧のフィルタープルダウン
  $('#trouble-filter, #method-filter').on('change', function() {
    const troubleValue = $('#trouble-filter').val();
    const methodValue = $('#method-filter').val();
    const baseUrl = window.location.pathname;
    const params = new URLSearchParams();
    
    if (troubleValue) {
      params.set('trouble', troubleValue);
    }
    if (methodValue) {
      params.set('method', methodValue);
    }
    
    const queryString = params.toString();
    const newUrl = queryString ? baseUrl + '?' + queryString : baseUrl;
    window.location.href = newUrl;
  });

  // お悩み相談アーカイブ（side-navi）年ごと開閉
  $(document).on('click', '.side-links-accordion dt', function() {
    const $dt = $(this);
    const $dd = $dt.next('dd');
    $dt.toggleClass('is-open');
    $dd.toggleClass('is-open');
  });
});
